<template>
  <el-input-number
    v-model="changeVal"
    :min="min"
    :max="max"
    :step="step"
    :step-strictly="stepStrictly"
    :precision="precision"
    :size="size"
    :disabled="disabled"
    :controls="controls"
    :controls-position="controlsPosition"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    @blur="blurValueHandler"
    @focus="focusValueHandler"
    @input.native="inputValueHandler"
    ref="inputNumberRef"
  />
</template>
<script>
import { InputNumber } from 'dygc-ui';

export default {
  name: 'InputFieldNumber',
  props: {
    ...InputNumber.props,
  },
  data() {
    return {
      fieldVal: this.value || 0,
      isNum: true,
    }
  },
  computed: {
    changeVal: {
      get() {
        return this.fieldVal;
      },
      set(val = 0) {
        const isNum = typeof val === 'number';
        this.isNum = isNum;
        const num = isNum ? val : val.value;
        if (isNum) {
          this.fieldVal = val;
        }
        this.$emit('change', num);
      }
    },
  },
  watch: {
    value(num) {
      if (this.isNum) {
        this.fieldVal = num;
      } else {
        this.isNum = true;
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    inputValueHandler(e) {
      const valText = e.target.value;
      if (valText === '' || valText === null || valText === undefined) {
        this.changeVal = { event: 'input', value: 0 };
      }
      let num = parseFloat(valText);
      if (!Number.isNaN(num)) {
        if (this.precision !== undefined) {
          num = this.$refs.inputNumberRef.toPrecision(num, this.precision);
        }
        if (num <= this.max && num >= this.min) {
          this.changeVal = { event: 'input', value: num };
        }
      }
    },
    blurValueHandler(e) {
      this.fieldVal = this.value;
      this.$emit('blur', e);
    },
    focusValueHandler(e) {
      this.changeVal = this.fieldVal;
      this.$emit('focus', e);
    },
  }
}
</script>